
export interface IChangeTypePermission {
    name: string;
    canAddPlan: boolean;
    canDeactivatePlan: boolean;
    canAddBenefit: boolean;



    canDeactivateBenefit: boolean;
    canAddAccountReceivable: boolean;
    canDeactivateAccountReceivable: boolean;
    canAddFeesAndPremium: boolean;
    canDeactivateFeesAndPremium: boolean;
    canAddStopLoss: boolean;
    canDeactivateStopLoss: boolean;
    canAddGroupStructure: boolean;
    canDeactivateGroupStructure: boolean;
    canLinkPlanBenefit: boolean;
    canLinkPlanFeesAndPremium: boolean;
    canLinkGroupStructurePlan: boolean;
    canLinkGroupStructureAccountReceivable: boolean;
    canLinkGroupStructureStopLoss: boolean;

    canAddGroupConfigurationNonstandard: boolean;
    canAddBenefitNonstandard: boolean;


}

export const ChangeTypePermissions: Record<number, IChangeTypePermission> = {
    // Admin Over Ride
    1: {
        name: "Admin Mode",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,
        
        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900002: {
        name: "Initial Setup",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900001: {
        name: "Comprehensive Renewal",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,
        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900010: {
        name: "Benefit Renewal",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,
        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900011: {
        name: "Financial Renewal",
        canAddPlan: false,
        canDeactivatePlan: false,
        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: false,
    },
    808900004: {
        name: "Comprehensive Change",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900000: {
        name: "Benefit Change",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900006: {
        name: "Financial Change",
        canAddPlan: false,
        canDeactivatePlan: false,
        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: false,
    },
    808900009: {
        name: "Stop Loss",
        canAddPlan: false,
        canDeactivatePlan: false,
        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: false,
        canAddBenefitNonstandard: false,
    },
    808900003: {
        name: "Administrative Change",
        canAddPlan: false,
        canDeactivatePlan: false,

        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: false,
        canAddBenefitNonstandard: false,
    },
    808900005: {
        name: "MNIL  Initial Setup Continuation",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900008: {
        name: "MNIL  Renewal Continuation",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900007: {
        name: "MNIL  Benefit Change Continuation",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900013: {
        name: "MNIL  Comprehensive Change Continuation",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900014: {
        name: "MNIL  Comprehensive Renewal Continuation",
        canAddPlan: true,
        canDeactivatePlan: true,
        canAddBenefit: true,
        canDeactivateBenefit: true,
        canAddAccountReceivable: true,
        canDeactivateAccountReceivable: true,
        canAddFeesAndPremium: true,
        canDeactivateFeesAndPremium: true,
        canAddStopLoss: true,
        canDeactivateStopLoss: true,
        canAddGroupStructure: true,
        canDeactivateGroupStructure: true,
        canLinkPlanBenefit: true,
        canLinkPlanFeesAndPremium: true,
        canLinkGroupStructurePlan: true,
        canLinkGroupStructureStopLoss: true,
        canLinkGroupStructureAccountReceivable: true,

        canAddGroupConfigurationNonstandard: true,
        canAddBenefitNonstandard: true,
    },
    808900012: {
        name: "PSA Change",
        canAddPlan: false,
        canDeactivatePlan: false,
        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: false,
        canAddBenefitNonstandard: false,
    },
    808900015: {
        name: "Post Cancel Update",
        canAddPlan: false,
        canDeactivatePlan: false,

        canAddBenefit: false,
        canDeactivateBenefit: false,
        canAddAccountReceivable: false,
        canDeactivateAccountReceivable: false,
        canAddFeesAndPremium: false,
        canDeactivateFeesAndPremium: false,
        canAddStopLoss: false,
        canDeactivateStopLoss: false,
        canAddGroupStructure: false,
        canDeactivateGroupStructure: false,
        canLinkPlanBenefit: false,
        canLinkPlanFeesAndPremium: false,
        canLinkGroupStructurePlan: false,
        canLinkGroupStructureStopLoss: false,
        canLinkGroupStructureAccountReceivable: false,

        canAddGroupConfigurationNonstandard: false,
        canAddBenefitNonstandard: false,
    },

}
